import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";

type TInventoryItem = Pick<EventInventoryRecord, "Item_ID" | "Listing_ID" | "Invoice_ID">;
type TTaggedListing = Pick<EventInventoryRecord, "Item_ID" | "Listing_ID" | "Tags">;

export const TAG_DELIMITER = "|";

export const splitTags = (tags: string | null | undefined) => (tags ? tags.split(TAG_DELIMITER).filter(Boolean) : []);

export const sameTag = (a: string, b: string) => a.trim().toLowerCase() === b.trim().toLowerCase();

export const hasTag = (tags: Array<string>, tag: string) => tags.some((x) => sameTag(x, tag));

export const effectiveTags = (listing: TTaggedListing, removed: Array<string> = []) =>
	splitTags(listing.Tags).filter((t) => !removed.includes(t));

export const unsoldItemIds = (inventory: Array<TInventoryItem>, listing: TInventoryItem) => {
	const ids = inventory.filter((x) => x.Listing_ID === listing.Listing_ID && !x.Invoice_ID).map((x) => x.Item_ID);
	return ids.length ? ids : [listing.Item_ID];
};

export const listingsMissingTag = <T extends TTaggedListing>(
	listings: Array<T>,
	tag: string,
	removals: Record<number, Array<string>>,
) => listings.filter((x) => !hasTag(effectiveTags(x, removals[x.Listing_ID]), tag));

export const matchingTagIds = (listingTags: Array<{ TagId: number; TagDesc: string }>, requested: Array<string>) =>
	listingTags.filter((t) => hasTag(requested, t.TagDesc)).map((t) => t.TagId);
